/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import JobsSection from "../../../../components/Jobs/JobsSection";
import JobPageMeta from "./JobPageMeta";
import WayWeWorkSection from "../../../../components/Jobs/WayWeWorkSection";
import Layout from "../../../Layouts/Layout";

const JobOverviewPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <JobPageMeta />
      <WayWeWorkSection />
      <JobsSection />
    </Layout>
  );
};

export default JobOverviewPage;
